import React from "react";
import { Flex } from "../../components/Flex";
import { Paragraph, Title } from "../../components/Text";
import { Scrollbar } from "../../components/Scrollbar";
import { Button } from "../../components/Button";
import { RemoveIcon } from "../../icons/RemoveIcon";
import { FixedForm } from "../../components/Forms";
import { fixPackageSize } from "../../utils";


const DownloadsPanel = ({ downloads, onClose, deselectPackage, downloadPackages, clearPackages }) => {

    return(
        <FixedForm onClose={onClose}>
            <Title h4 margin={{ bottom: "24px" }} >Packages to download</Title>
            <Scrollbar>
                <Flex direction="column" gap={{ bottom: 16 }} padding={{ right: "15px"}}>
                    {Object.keys(downloads).map(key => (
                        <Flex key={key} justify="space-between" align="center">
                            <Flex gap={{ right: 4 }}>
                                <Paragraph color="var(--sp-label-color)" bold>{downloads[key].name}</Paragraph>
                                <Paragraph color="var(--sp-label-color)">({fixPackageSize(downloads[key].size)})</Paragraph>
                            </Flex>
                            <RemoveIcon color="var(--sp-error-color)" hoverColor="var(--sp-error-hover-color)" size={18} onClick={() => deselectPackage(key)}/>
                        </Flex>
                    ))}
                </Flex>
            </Scrollbar>
            <Flex gap={{ right: 12 }} justify="flex-end">
                <Button link onClick={() => clearPackages()}>Clear</Button>
                <Button onClick={downloadPackages}>Download</Button>
            </Flex>
        </FixedForm>
    );
};

export { DownloadsPanel };